import React from "react";
import { makeStyles, Typography, Box } from "@material-ui/core";
import { Theme, Dialog, DialogContent, DialogProps } from "@material-ui/core";
import { PrimaryButton } from "../button/PrimaryButton";
import { SecondaryButton } from "../button/SecondaryButton";
import Fingerprint from "@material-ui/icons/Fingerprint";
import { IFingerUnit } from "../../store/models/FingerPrintModel";
import FullLoader from "../../components/Loader/FullLoader.component";
import { Slide, SlideProps } from "@material-ui/core";
import fingerImage from "../../assets/finger.png";
import useCaptueFingerprint from "../../hooks/useCaptureFingerprint";

const useStyles = makeStyles((_theme: Theme) => ({
  title: {
    font: "normal normal bold 18px/23px Muli",
    color: "#FA5A00",
    marginBottom: "20px",
    display: "flex",
    justifyContent: "center",
    marginTop: 31,
  },
  boxCapture: {
    width: "auto",
    height: "auto",
    maxHeight: "40vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 0",
    boxShadow: "0px 3px 6px #00000033",
    border: "1px solid #B2B2B2",
    borderRadius: "10px",
    marginBottom: 20,
    marginLeft: 10,
    marginRight: 10,
    overflow: "hidden",
    [_theme.breakpoints.up("md")]: {
      maxWidth: "40vw",
    },
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 30,
    gap: "1em",
  },
  fingerIcon: {
    fontSize: "100px",
    padding: "99px 0",
    color: "#00000008",
  },
  captureBtnContainer: {
    width: "185px",
    height: "70%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 20,
    marginLeft: "auto",
    marginRight: "auto",
  },
  iconButton: {
    fontSize: "25px !important",
  },
  fingerCaptureContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& img": {
      filter: "blur(4px)",
      width: "100%",
      [_theme.breakpoints.down("md")]: {
        width: "80%",
      },
    },
    position: "relative",
  },
  sensitiveData: {
    color: "#FFE200",
    zIndex: 1,
    position: "absolute",
    transform: "matrix(0.96, -0.29, 0.29, 0.96, 0, 0)",
    textShadow: "0px 2px 2px #00000080",
    fontSize: "22px",
    fontWeight: 500,
  },
}));

const Transition = React.forwardRef<unknown, SlideProps>((props, ref) => (
  <Slide direction="up" timeout={10000} ref={ref} {...props} />
));

interface Props {
  isOpen: boolean;
  isClose: any;
  finger: any | null;
  hand: any | null;
  arrayFinger?: IFingerUnit[];
  handleAcceptButton?: Function;
  clearTimer?: Function;
  keyProp?: number;
  fingerId: any;
  changeTab?: any;
}

const CaptureDialog = ({
  isOpen,
  isClose,
  finger,
  hand,
  arrayFinger,
  handleAcceptButton,
  keyProp,
  fingerId,
  clearTimer,
}: Props) => {
  const classes = useStyles();
  // local states
  const [maxWidth] = React.useState<DialogProps["maxWidth"]>("xs");

  // react hooks
  const {
    onConfirmClick,
    handleCancel,
    handleCaptureFinger,
    capture,
    nextFinger,
    loadingFingerPrint,
  } = useCaptueFingerprint({
    fingerId,
    keyProp,
    arrayFinger,
    handleAcceptButton,
    isClose,
    clearTimer,
  });

  return (
    <>
      <Dialog
        maxWidth={maxWidth}
        open={isOpen}
        TransitionComponent={Transition}
      >
        <DialogContent>
          <Typography className={classes.title}>
            {`Captura ${finger} mano ${hand}`}
          </Typography>
          <div className={classes.captureBtnContainer}>
            <PrimaryButton
              title={"Capturar"}
              props={{
                disabled: loadingFingerPrint || !!capture,
                endIcon: <Fingerprint className={classes.iconButton} />,
                onClick: handleCaptureFinger,
              }}
            ></PrimaryButton>
          </div>
          <Box className={classes.boxCapture}>
            {capture ? (
              <div className={classes.fingerCaptureContainer}>
                <p className={classes.sensitiveData}>DATO SENSIBLE</p>
                <img src={fingerImage} alt="imagebase64" />
              </div>
            ) : (
              <Fingerprint className={classes.fingerIcon} />
            )}
          </Box>
          <div className={classes.buttonsContainer}>
            <div style={{ width: "167px", height: "40px" }}>
              <SecondaryButton
                title={"Cancelar"}
                props={{
                  disabled: loadingFingerPrint,
                  onClick: handleCancel,
                }}
              ></SecondaryButton>
            </div>
            <div style={{ width: "167px", height: "40px" }}>
              <PrimaryButton
                title={"Aceptar"}
                props={{ onClick: onConfirmClick, disabled: nextFinger }}
              ></PrimaryButton>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <FullLoader open={loadingFingerPrint} />
    </>
  );
};

export default CaptureDialog;
